<template>
  <div class="addCommondity">
    <div class="goodsManageDetailPage">
      <div class="banner">
        <img src="../../assets/images/banner1.png" alt="" />
      </div>
      <div class="breadcrumb flex-rowc">
        <!-- <div class="breadcrumb_icon">
          <i class="iconfont icon-shangpinsku"></i>
        </div> -->
        <div class="breadcrumb_item">促销优惠&市场活动</div>
        <div class="breadcrumb_item_arrow"></div>
        <div class="breadcrumb_item">市场活动管理</div>
      </div>

      <div class="main_content">
        <div class="block">
          <h1><span class="mark">*</span>banner图</h1>
          <p class="red">JPG或者PNG格式，尺寸比例为500*750像素</p>
          <div class="img_box">
            <van-uploader
              v-model="fileList"
              @delete="formData.banner = ''"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-count="1"
            />
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>奖项等级：</h1>
          <div class="input_box">
            <van-field
              v-model="formData.levelid"
              placeholder="请输入奖项等级"
            />
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>商品：</h1>
          <div class="input_box">
            <van-field
              v-model="formData.goodsid"
              placeholder="请输入商品"
            />
          </div>
        </div>
        <div class="block">
          <h1><span class="mark">*</span>排序：</h1>
          <div class="input_box">
            <van-field
              v-model="formData.sortno"
              placeholder="请输入排序"
            />
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">确认</div>
      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i> 返回
      </div>
      <!-- <div class="return-fixd">
        
      </div> -->
    </div>
  </div>
</template>

<script>
import { uploadPosterImage, encryptstringview } from "../../api/api";
import {
  getActivityBannerDetail,
  editActivityBanner,
  addActivityBanner,
} from "../../api/shop";
export default {
  name: "shopBannerDetail",
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      isShow: false,
      popupType: 1,
      popupDate: 1,

      radio: "",
      searchText: "",
      isShowStyle: false,
      scrollTop: 0,

      formData: {
        id: "",
        actid: "",
        banner: "",
        levelid: "",
        goodsid: "",
        sortno: "",
      },
      fileList: []
    };
  },
  created() {
    let { routerList, OPENID } = this.$store.state;
    let { name } = this.$route;
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, actid } = JSON.parse(res.jsondata);
        this.formData.actid = actid;
        this.formData.id = id;
        if (id != "") {
          this.getActivityBannerDetail(id);
        }
      } else {
        this.$router.back();
      }
    },

    // 获取活动详情
    getActivityBannerDetail(id) {
      getActivityBannerDetail({ id }).then((res) => {
        this.formData.actid = res.actid;
        this.formData.banner = res.banner;
        this.fileList.push({ url: this.baseUrl + res.banner });
        this.formData.levelid = res.levelid;
        this.formData.goodsid = res.goodsid;
        this.formData.sortno = res.sortno;
      });
    },

    // 图片上传之前处理
    beforeRead(file) {
      const imgformat = /image\/(png|jpg|jpeg)$/;
      if (!imgformat.test(file.type)) {
        this.$toast.fail("请上传 jpg/png 格式图片");
        return false;
      }
      return true;
    },
    // 检测图片的宽高
    checkWidthAndHeight(file) {
      return new Promise((resolve, reject) => {
        let { isType } = this;
        let img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = function () {
          let width = img.width;
          var height = img.height;
          console.log("当前图片的宽高:" + width, height);
          if (isType == 1) {
            if (width == 500 && height == 500) {
              reject(true);
            } else {
              resolve(false);
            }
          }
        };
      });
    },
    // 图片上传后处理
    afterRead(e) {
      var formData = new FormData();
      formData.append("imgfile", e.file);
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
        duration: 0,
      });
      uploadPosterImage(formData).then((res) => {
        if (res.result) {
          this.formData.banner = res.code;
          Toast.clear();
        } else {
          this.$toast.fail(res.message || "服务器报错，请稍后～");
          Toast.clear();
        }
      });
    },

    // 返回上一页
    handleReturn() {
      history.back();
    },

    // 提交数据
    query() {
      let { formData } = this;
      if (formData.sortno == "") {
        this.$toast("请上传banner");
        return;
      }
      if (formData.levelid == "") {
        this.$toast("请输入奖项等级");
        return;
      }
      if (formData.goodsid == "") {
        this.$toast("请输入商品");
        return;
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      if (formData.id == "") {
        this.loading = true;
        addActivityBanner(formData).then((res) => {
          if (res.result) {
            this.$toast.success(res.message);
            setTimeout(() => {
              this.$router.back();
            }, 2000);
          } else {
            Toast.clear();
            this.$toast.fail(res.message);
          }
        });
      } else {
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        editActivityBanner(formData).then((res) => {
          if (res.result) {
            this.$toast.success(res.message);
            setTimeout(() => {
              this.$router.back();
            }, 2000);
          } else {
            Toast.clear();
            this.$toast.fail(res.message);
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageDetailPage {
  padding-bottom: 380px;
  .main_content {
    font-size: 30px;
    color: #444444;
    h1 {
      text-align: center;
      font-weight: 400;
      margin-bottom: 35px;
    }
    input {
      text-align: center;
    }
    .block {
      margin-bottom: 100px;
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
    }
    .input_box {
      margin-bottom: 30px;
    }
    p {
      line-height: 30px;
      font-size: 22px;
      color: #ff0012;
      text-align: center;
    }
  }
}
</style>